/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestDto } from '../../models/test-dto';

export interface PreDocumentControllerAiTest$Params {
}

export function preDocumentControllerAiTest(http: HttpClient, rootUrl: string, params?: PreDocumentControllerAiTest$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
  const rb = new RequestBuilder(rootUrl, preDocumentControllerAiTest.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestDto>;
    })
  );
}

preDocumentControllerAiTest.PATH = '/api/pre-document/ai-test';
